import { api } from '@/global/services/api'
import { FormDataBuilder } from '@/global/services/helpers/formDataBuilder'

const MODULE = 'road-maintenance'

export function useWorkOrderDetailsApi () {
  const fetchDetailed = async (projectId) => {
    const { data } = await api(MODULE).get(`projects/${projectId}/detailed`)
    return data
  }

  const saveProject = async (projectId, payload) => {
    const formData = new FormDataBuilder().build(payload)
    formData.append('_method', 'PATCH')
    const { data } = await api(MODULE).post(`projects/${projectId}`, formData)
    return data
  }

  const savePhase = async (projectId, phaseId, payload) => {
    const isEditing = !!phaseId
    const formData = new FormDataBuilder().build(payload)
    if (isEditing) {
      formData.append('_method', 'PATCH')
    }
    const endpoint = isEditing ? `projects/${projectId}/phases/${phaseId}` : `projects/${projectId}/phases`
    const { data } = await api(MODULE).post(endpoint, formData)
    return data
  }

  const deletePhase = async (projectId, phaseId) => {
    await api(MODULE).delete(`projects/${projectId}/phases/${phaseId}`)
  }

  const saveLocation = async (locationId, payload) => {
    const isEditing = !!locationId
    const formData = new FormDataBuilder().build(payload)
    if (isEditing) {
      formData.append('_method', 'PATCH')
    }
    const endpoint = isEditing ? `work-orders/plan-locations/${locationId}` : 'work-orders/plan-locations'
    const { data } = await api(MODULE).post(endpoint, formData)
    return data
  }

  const deleteLocation = async (locationId) => {
    await api(MODULE).delete(`work-orders/plan-locations/${locationId}`)
  }

  const saveActivity = async (activityId, payload) => {
    const isEditing = !!activityId
    const formData = new FormDataBuilder().build(payload)
    if (isEditing) {
      formData.append('_method', 'PATCH')
    }
    const endpoint = isEditing ? `work-orders/plan-location-activities/${activityId}` : 'work-orders/plan-location-activities'
    const { data } = await api(MODULE).post(endpoint, formData)
    return data
  }

  const deleteActivity = async (activityId) => {
    await api(MODULE).delete(`work-orders/plan-location-activities/${activityId}`)
  }

  const syncProducts = async (activityId, products) => {
    const { data } = await api(MODULE).put(`work-orders/plan-location-activities/${activityId}/products`, { products })
    return data
  }

  const copyProductsFromOffer = async (activityId) => {
    const { data } = await api(MODULE).post(`work-orders/plan-location-activities/${activityId}/products/copy-from-offer`)
    return data
  }

  // Road information (traffic activity feed) of the traffic regulation this
  // project came from - same response shape as the regulation's own
  // road-information endpoint, but read-only here. Null for projects that
  // aren't tied to a regulation.
  const fetchTrafficActivityFeed = async (projectId) => {
    const { data } = await api(MODULE).get(`projects/${projectId}/traffic-activity-feed`)
    return data
  }

  const fetchAttachments = async (projectId) => {
    const { data } = await api(MODULE).get(`projects/${projectId}/attachments`)
    return data
  }

  return {
    fetchDetailed,
    saveProject,
    savePhase,
    deletePhase,
    saveLocation,
    deleteLocation,
    saveActivity,
    deleteActivity,
    syncProducts,
    copyProductsFromOffer,
    fetchTrafficActivityFeed,
    fetchAttachments
  }
}
